import React from 'react';
import { withRouter } from 'react-router-dom';
// import Background from '../images/background_image_Login.jpg';
// import { AppThemeContext } from '../contexts/AppThemeContext';
import SignIn from '../components/SignIn';


const SignInPage = (props) => {
    // const { theme } = useContext(AppThemeContext);

    const myStyles = {
        section: {
            width: "100%",
            height: "100%",
            justifyContent: 'center',
            backgroundSize: 'cover',
            // backgroundImage: `url(${Background})`
        },
    }

    return (
        <section style={myStyles.section} >
            <SignIn />
        </section>
    )
}
export default withRouter(SignInPage);